//GET_ALL_EXPENSE_REQUESTS
export const GET_ALL_EXPENSE_REQUESTS_REQUEST =
  "GET_ALL_EXPENSE_REQUESTS_REQUEST";
export const GET_ALL_EXPENSE_REQUESTS_SUCCESS =
  "GET_ALL_EXPENSE_REQUESTS_SUCCESS";
export const GET_ALL_EXPENSE_REQUESTS_FAIL = "GET_ALL_EXPENSE_REQUESTS_FAIL";
//GET_ALL_EXPENSE_HISTORY
export const GET_ALL_EXPENSE_HISTORY_REQUEST =
  "GET_ALL_EXPENSE_HISTORY_REQUEST";
export const GET_ALL_EXPENSE_HISTORY_SUCCESS =
  "GET_ALL_EXPENSE_HISTORY_SUCCESS";
export const GET_ALL_EXPENSE_HISTORY_FAIL = "GET_ALL_EXPENSE_HISTORY_FAIL";

//ADD_EXPENSE_OF_USERS
export const ADD_EXPENSE_OF_USERS_REQUEST = "ADD_EXPENSE_OF_USERS_REQUEST";
export const ADD_EXPENSE_OF_USERS_SUCCESS = "ADD_EXPENSE_OF_USERS_SUCCESS";
export const ADD_EXPENSE_OF_USERS_FAIL = "ADD_EXPENSE_OF_USERS_FAIL";

//APPROVE_EXPENSE_REQUEST
export const APPROVE_EXPENSE_REQUEST_REQUEST =
  "APPROVE_EXPENSE_REQUEST_REQUEST";
export const APPROVE_EXPENSE_REQUEST_SUCCESS =
  "APPROVE_EXPENSE_REQUEST_SUCCESS";
export const APPROVE_EXPENSE_REQUEST_FAIL = "APPROVE_EXPENSE_REQUEST_FAIL";

//REJECT_EXPENSE_REQUEST
export const REJECT_EXPENSE_REQUEST_REQUEST = "REJECT_EXPENSE_REQUEST_REQUEST";
export const REJECT_EXPENSE_REQUEST_SUCCESS = "REJECT_EXPENSE_REQUEST_SUCCESS";
export const REJECT_EXPENSE_REQUEST_FAIL = "REJECT_EXPENSE_REQUEST_FAIL";

//DELETE_EXPENSE_REQUEST
export const DELETE_EXPENSE_REQUEST_REQUEST = "DELETE_EXPENSE_REQUEST_REQUEST";
export const DELETE_EXPENSE_REQUEST_SUCCESS = "DELETE_EXPENSE_REQUEST_SUCCESS";
export const DELETE_EXPENSE_REQUEST_FAIL = "DELETE_EXPENSE_REQUEST_FAIL";
